import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import queryString from "query-string";
import store from "src/redux";
import { updateProfile } from "src/redux/auth";
import useAuth from "src/hooks/selectors/useAuth";

const usePaymentRedirect = ({ fetchProfile }: { fetchProfile?: boolean }) => {
	const location = useLocation();
	const [loading, setLoading] = useState(false);
	const [status] = useState("");
	const auth = useAuth();
	const refetchProfile = useCallback(() => {
		axios.get("/auth/profile").then(({ data }: any) => {
			if (data.data?.id) {
				store.dispatch(updateProfile(data.data));
				setLoading(false);
			}
		});
	}, []);

	useEffect(() => {
		let url = location.search;
		let params = queryString.parse(url);
		if (params.payment) {
			axios
				.get(`/company/payments/${params.payment}`)
				.then(({ data }) => {
					const payment = data?.data || {};
					if (
						["completed", "reserved", "pending"].includes(
							payment?.status
						)
					) {
						const event = {
							event: "PaymentEvent",
							userId: auth.id,
							reference: payment?.reference,
							price: payment?.total,
							payment_method: payment?.type,
						};
						if (process.env.NODE_ENV !== "development") {
							window.dataLayer.push(event);
						}
					}
				});

			setLoading(true);
			setTimeout(() => {
				refetchProfile();
			}, 3000);
		}
	}, [auth.id, fetchProfile, location.search, refetchProfile, setLoading]);

	return [loading, status] as [boolean, string];
};
export default usePaymentRedirect;
